<template>
  <div class="card no-body">
    <div class="card-header d-flex">
        <h5 class="h3 mb-0">Pending Invites</h5>
      <div class="ml-auto p-1">
        <b-input-group size="sm">
          <b-form-input
            v-model="searchValue"
            type="search"
            placeholder="Search"
          ></b-form-input>
        </b-input-group>
      </div>
    </div>

    <div v-if="invites && invites.length > 0">
        <b-list-group flush class="account-pending-invites-list-group">
          <account-pending-invites-item v-for="invite in filterInvites()" :key="invite.inviteId" :invite="invite" :accountRoles="rootWrapper.accountRolesList" :projectRoles="rootWrapper.projectRolesList" @revoke-pending-invite="revokePendingInvite" class="flex-column align-items-start"></account-pending-invites-item>
        </b-list-group>
    </div>
    <div v-else class="text-center p-3">
        <div> No pending invites. </div>
    </div>
    <div class="card-footer">
      <b-form-invalid-feedback :state="!errorMessage" class="text-center">
          {{errorMessage}}
      </b-form-invalid-feedback>
    </div>
  </div>
</template>
<script>
import { AccountUserListRequest, RoleRevokeUserInviteRequest } from '#/protobuf/service_account_pb';
import AccountPendingInvitesItem from '#/ui/Components/AccountPendingInvitesItem.vue';

export default {
  components: {
    AccountPendingInvitesItem,
  },
  props: {
  },
  data() {
    return {
      rootWrapper: undefined,
      searchValue: '',
      errorMessage: undefined,
    };
  },
  created() {
    this.loadAccountRoles();
  },
  computed: {
    invites() {
      if (this.rootWrapper && this.rootWrapper.pendingUsersList) {
        return this.rootWrapper.pendingUsersList.map((item) => item);
      } return [];
    },
  },
  methods: {
    filterInvites() {
      return this.rootWrapper.pendingUsersList.map((item) => item).filter((invite) => invite.email.toLowerCase().match(new RegExp(this.searchValue.trim().toLowerCase(), 'g')));
    },
    async loadAccountRoles() {
      const request = new AccountUserListRequest();
      return this.$store.dispatch('accounts/loadAccountUsers', request).then((data) => {
        this.rootWrapper = data;
        console.info('loaded account roles', this.rootWrapper);
      }).catch((error) => {
        console.warn('error loadAccountUsers: ', error);
        this.errorMessage = 'Error loading account user';
      }).finally(() => {
        this.loaded = true;
      });
    },
    revokePendingInvite(inviteId) {
      const request = new RoleRevokeUserInviteRequest();
      request.setInviteId(inviteId);
      // eslint-disable-next-line no-unused-vars
      return this.$store.dispatch('accounts/revokeUserInvite', request).then((response) => {
        const index = this.invites.findIndex((invite) => invite.inviteId === inviteId);
        console.log('removing revoked invite', inviteId, index);
        if (index >= 0) {
          this.rootWrapper.pendingUsersList = this.invites.filter((item, ind ) => ind !== index);
        }
      }).catch((error) => {
        console.log('error attempting to revoke invite', error.message);
        this.errorMessage = `error attempting to revoke invite ${error.message}`;
      });
    },
  },
};
</script>
<style scoped>
</style>
